import styled from "styled-components";
import { ClientSettingsContentContainerDefaultBox } from "./client-settings-content-container.default.box";

export const ClientSettingsContentContainerSIBox = styled(ClientSettingsContentContainerDefaultBox)`
    background: ${({ theme }) => theme.colors.background};
`